<template>
    <div class="wrapper wrapper-content">
        <div class="row">
            <div class="ibox float-e-margins">
                <div class="ibox-content">
                    <div class="row">
                        <div class="col-sm-5 m-b-xs">
                            <el-form :label-position="labelPosition" label-width="80px" :model="form">
                                <el-form-item label="类型名称">
                                        <el-input v-model="form.name"></el-input>
                                </el-form-item>
                                <el-form-item label="父级ID">
                                    <el-cascader
                                            :options="options"
                                            v-model="form.pid"
                                            @change="handleChange">
                                    </el-cascader>
                                </el-form-item>
                                <el-form-item v-if="id">
                                    <el-button type="primary" @click="onUpdate">确认修改</el-button>
                                </el-form-item>
                                <el-form-item v-else>
                                    <el-button type="primary" @click="onSubmit">立即创建</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { categoryList, creatCategory, detailCategory, updateCategory } from '@/services/category'

  export default {
    name: 'CreatCategoryPage',
    data() {
      return {
        id:this.$route.params.id,
        children: [{
          value: '2',
          label: '二级菜单'
        }],
        labelPosition: 'left',
        form:{
          pid:[],
          name:''
        },
        options: []
      };
    },
    mounted(){
      if (this.id) {
        var uid = this.id;
        detailCategory({id:uid}).then(res => {
          console.log(res);
          this.form.name = res.responseData.name
        });
      }
      categoryList().then(res => {
        var list = [] ,obj = {};
        for(var i in res.items){
          list.push({
            value:res.items[i].pid,
            label:res.items[i].name,
            children:this.children
          });
        }
        this.options = list;
      });
    },
    methods: {
      handleChange(value) {
        console.log(value);
      },
      onUpdate(){

      },
      onSubmit(){
        console.log();
        var myForm = {};
        myForm.name = this.form.name;
        myForm.pid = this.form.pid[this.form.pid.length - 1];

        console.log(myForm);
        creatCategory(myForm).then(res => {
          console.log(res);
          if (res.code == 0) {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.$router.push('/category');
          }
        });
      },
      onUpdate(){
        this.form.id = this.id;
        console.log(this.form);
        updateCategory(this.form).then(res => {
          console.log(res);
          if(res.code == 0){
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.$router.push('/category');
          }
        }).catch(error => {});
      },
    }

  };
</script>

<style scoped>

</style>
